<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div
    class="text-body-2"
  >
    <div
      class="py-1"
    >
      <template>
        <div
          class="d-flex align-start py-2"
        >
          <div style="width: 100%">
            <div

              class="d-flex align-center"
            >
              <div class="text-body-2 font-weight-medium text-capitalize">
                {{ ag.name }}
              </div>
              <v-spacer />

              <v-icon @click="$emit('remove-ag')">
                mdi-delete
              </v-icon>
            </div>
            <div class="d-flex mt-4 flex-wrap">
              <v-chip
                v-if="false"
                class="d-flex align-center justify-center mr-2 mb-2 pa-0"
                label
                outlined
                style="width: 36px;height: 36px"
              >
                <v-icon>mdi-plus</v-icon>
              </v-chip>
              <div
                v-for="a in attributeList"
                :key="a.id"
              >
                <v-btn
                  class="pa-3 mb-2 mr-2 text-body-2 text-capitalize"
                  label
                  large
                  elevation="0"
                  :loading="loadingMap[a.id] === true"
                  style="height: 36px"
                  @click="toggleAttribute(a.id,ag.id)"
                >
                  {{ a.name }}
                  <v-icon
                    class="ml-2"
                    color="amber darken-2"
                    right
                    small
                  >
                    {{ !isActive(a.id) ? 'mdi-checkbox-blank-outline' : 'mdi-checkbox-marked' }}
                  </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <v-spacer />
        </div>
      </template>
    </div>
    <v-divider class="mb-4" />
  </div>
</template>

<script>

export default {
  name: 'AttributeCard',
  components: { },
  props: {
    ag: {},
    selectedAIdList: {}
  },
  data () {
    return {
      loadingMap: {},
      agName: ''
    }
  },
  computed: {
    attributeList () {
      return this.ag?.attributes ?? []
    },
    selected () {
      return this.ag?.attributes?.filter(it => this.selectedAIdList.includes(it.id.toString())) ?? []
    }
  },
  watch: {
    ag: {
      immediate: true,
      deep: true,
      handler (val) {
        this.agName = val.name
      }
    }
  },

  methods: {
    isActive (id) {
      return this.selectedAIdList.includes(id.toString())
    },
    async toggleAttribute (aId, agId) {
      // set loading only for the clicked attribute button
      if (this.$set) {
        this.$set(this.loadingMap, aId, true)
      } else {
        this.loadingMap[aId] = true
      }

      // Provide a callback for parent to call when async work is finished
      const done = () => {
        if (this.$set) {
          this.$set(this.loadingMap, aId, false)
        } else {
          this.loadingMap[aId] = false
        }
      }

      // Emit event to parent; parent should execute async logic then invoke done()
      this.$emit('toggle-attribute', aId, agId, done)
    }
  }
}
</script>

<style scoped>

</style>
